import TableStrings from "../../../../config/language_table";

export const OptionsDefault = {
    title: false,
    print: false,
    filter: false,
    download: false,
    search: false,
    viewColumns: false,
    size: "small",
    responsive: 'scrollFullHeight',
    rowsPerPage: 4,
    rowsPerPageOptions: [],
    textLabels: TableStrings['pt'],
};
